import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect, useState, type HTMLAttributes, type ReactNode, type JSX } from 'react';
import cn from 'classnames';
import { Icon, IconSize } from '@sbt-web/ui';
import S from './index.module.scss';
type Props = HTMLAttributes<HTMLDetailsElement> & {
  children: ReactNode;
  summary: ReactNode;
  className?: string;
  detailsTestId?: string;
  summaryTestId?: string;
  open?: boolean;
  renderIcon?: (isOpen: boolean) => ReactNode;
  onDetailsToggle?: (isOpen: boolean) => void;
};
const defaultIcon = (isOpen: boolean): JSX.Element => <Icon name={isOpen ? 'ArrowUp' : 'ArrowDown'} iconSize={IconSize.SM} />;
const ToggleDetails = t0 => {
  const $ = _c(32);
  let children;
  let className;
  let detailsTestId;
  let onDetailsToggle;
  let restOfProps;
  let summary;
  let summaryTestId;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      summary,
      className,
      detailsTestId,
      summaryTestId,
      open: t1,
      renderIcon: t2,
      onDetailsToggle,
      ...restOfProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = detailsTestId;
    $[4] = onDetailsToggle;
    $[5] = restOfProps;
    $[6] = summary;
    $[7] = summaryTestId;
    $[8] = t1;
    $[9] = t2;
  } else {
    children = $[1];
    className = $[2];
    detailsTestId = $[3];
    onDetailsToggle = $[4];
    restOfProps = $[5];
    summary = $[6];
    summaryTestId = $[7];
    t1 = $[8];
    t2 = $[9];
  }
  const open = t1 === undefined ? false : t1;
  const renderIcon = t2 === undefined ? defaultIcon : t2;
  const [isOpen, setIsOpen] = useState(open);
  const detailsRef = useRef(null);
  let t3;
  let t4;
  if ($[10] !== onDetailsToggle) {
    t3 = () => {
      const detailsElement = detailsRef.current;
      if (!detailsElement) {
        return;
      }
      const handleToggle = () => {
        const open_0 = detailsElement.open;
        setIsOpen(open_0);
        if (onDetailsToggle) {
          onDetailsToggle(open_0);
        }
      };
      detailsElement.addEventListener("toggle", handleToggle);
      return () => {
        detailsElement.removeEventListener("toggle", handleToggle);
      };
    };
    t4 = [onDetailsToggle];
    $[10] = onDetailsToggle;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  useEffect(t3, t4);
  let t5;
  if ($[13] !== className) {
    t5 = cn(S.Details, className);
    $[13] = className;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== isOpen || $[16] !== renderIcon) {
    t6 = renderIcon?.(isOpen);
    $[15] = isOpen;
    $[16] = renderIcon;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t6) {
    t7 = <div className={S.IconSlot}>{t6}</div>;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== summary || $[21] !== summaryTestId || $[22] !== t7) {
    t8 = <summary className={S.Summary} data-testid={summaryTestId}>{summary}{t7}</summary>;
    $[20] = summary;
    $[21] = summaryTestId;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== children) {
    t9 = <div className={S.Content}>{children}</div>;
    $[24] = children;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== detailsTestId || $[27] !== restOfProps || $[28] !== t5 || $[29] !== t8 || $[30] !== t9) {
    t10 = <details ref={detailsRef} className={t5} data-testid={detailsTestId} {...restOfProps}>{t8}{t9}</details>;
    $[26] = detailsTestId;
    $[27] = restOfProps;
    $[28] = t5;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};
export { ToggleDetails };